export default __webpack_public_path__ + "static/media/graphql.7945cc4f.svg";